
export default class FiscalData {
  constructor (attributes = {}) {
    this.legalName = attributes.legal_name ?? attributes.legalName ?? ''
    this.address = attributes.address ?? ''
    this.postalCode = attributes.postal_code ?? attributes.postalCode ?? ''
    this.city = attributes.city ?? ''
    this.state = attributes.state ?? ''
    this.country = 'ES'
    this.nif = attributes.nif ?? ''
    this.taxAgency = parseInt(attributes.tax_agency ?? attributes.taxAgency ?? 0)
  }

  get veriFactu () {
    return this.taxAgency === 0
  }
}
